var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162167",
    "data-name": "Group 162167",
    transform: "translate(-934 -694)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 24,
    height: 24,
    transform: "translate(934 694)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162166",
    "data-name": "Group 162166",
    transform: "translate(-12866.439 -2356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83916",
    "data-name": "Path 83916",
    d: "M225.519,143.492l-.536,14.439a.487.487,0,0,1-.477.458h-9.25a.487.487,0,0,1-.477-.458l-.536-14.439a.723.723,0,0,0-1.444.053l.535,14.439a1.932,1.932,0,0,0,1.921,1.848h9.25a1.931,1.931,0,0,0,1.921-1.848l.535-14.439a.723.723,0,0,0-1.444-.053Z",
    transform: "translate(13592.558 2912.167)",
    fill: "#10384f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83917",
    "data-name": "Path 83917",
    d: "M338.8,202.194v10.079a.593.593,0,1,0,1.186,0V202.194a.593.593,0,1,0-1.186,0Z",
    transform: "translate(13473.047 2856.175)",
    fill: "#10384f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83918",
    "data-name": "Path 83918",
    d: "M277.2,202.212l.3,10.079a.593.593,0,0,0,1.185-.035l-.3-10.079a.593.593,0,1,0-1.185.035Z",
    transform: "translate(13531.466 2856.175)",
    fill: "#10384f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83919",
    "data-name": "Path 83919",
    d: "M395.1,202.174l-.3,10.079a.593.593,0,0,0,1.185.035l.3-10.079a.593.593,0,1,0-1.185-.035Z",
    transform: "translate(13419.933 2856.178)",
    fill: "#10384f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83920",
    "data-name": "Path 83920",
    d: "M196.725,135.882h14.493a.741.741,0,0,0,0-1.482H196.725a.741.741,0,0,0,0,1.482Z",
    transform: "translate(13608.469 2920.12)",
    fill: "#10384f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83921",
    "data-name": "Path 83921",
    d: "M281.963,89.824l.309-1.08a.719.719,0,0,1,.607-.457h2.673a.718.718,0,0,1,.607.457l.309,1.08,1.425-.407-.309-1.08a2.19,2.19,0,0,0-2.032-1.532h-2.673a2.19,2.19,0,0,0-2.032,1.532l-.309,1.08Z",
    transform: "translate(13528.225 2965.196)",
    fill: "#10384f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.dacb81114259d702f26d297c1cb3928a.svg";
export { ForwardRef as ReactComponent };